module.exports = __webpack_public_path__ + "img/preview-15.ce5b2d7c.webp";